import { useState } from 'react';

export default function HomePage() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    empresa: '',
    cargo: '',
    telefone: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d453cbej3hkp5gme3fdg', {
        method: 'POST',
        body: formDataToSend
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          email: '',
          empresa: '',
          cargo: '',
          telefone: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 text-gray-900">
      {/* Header */}
      <header className="bg-white/95 backdrop-blur-sm border-b border-blue-200 shadow-sm">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-center">
            <div className="text-sm text-gray-500 bg-blue-50 px-4 py-2 rounded-full">
              Evento Privado • Apenas Convidados
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section 
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.8)), url('https://public.readdy.ai/ai/img_res/83ba69d43ec7297e3f21666ca012ffe0.jpg')`
        }}
      >
        <div className="container mx-auto px-6 text-center">
          <div className="max-w-4xl mx-auto">
            {/* Logos */}
            <div className="flex items-center justify-center space-x-12 mb-8">
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/6/62/Fortinet_logo.svg" 
                alt="Fortinet" 
                className="h-8 brightness-0 invert"
              />
              <img 
                src="https://brasiline.com.br/wp-content/uploads/2021/12/Brasiline-Logo-header.svg" 
                alt="Brasiline" 
                className="h-10 brightness-0 invert"
              />
              <img 
                src="https://static.readdy.ai/image/70e35cca528b96dcee707f2af83b401f/f23117ed88c4b1b31858b928b9726aa6.png" 
                alt="Scansource" 
                className="h-10 brightness-0 invert"
              />
            </div>
            
            <h1 className="text-6xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
              Brasiline Cyber Day
            </h1>
            <p className="text-2xl md:text-3xl text-gray-200 mb-8 font-light">
              Conectando Estratégia, Pessoas e Inovação para um Futuro Digital Seguro
            </p>
            <div className="flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-8 mb-12">
              <div className="flex items-center space-x-2 text-blue-400 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/20">
                <i className="ri-calendar-line text-xl"></i>
                <span className="text-lg font-medium text-white">26 de Novembro de 2025</span>
              </div>
              <div className="flex items-center space-x-2 text-blue-400 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/20">
                <i className="ri-time-line text-xl"></i>
                <span className="text-lg font-medium text-white">19h às 22h</span>
              </div>
              <div className="flex items-center space-x-2 text-blue-400 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/20">
                <i className="ri-map-pin-line text-xl"></i>
                <span className="text-lg font-medium text-white">Fogo de Chão - Botafogo, RJ</span>
              </div>
            </div>
            <button
              onClick={() => {
                const formSection = document.getElementById('inscricao-cyber-day');
                if (formSection) {
                  formSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold py-4 px-8 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer text-lg"
            >
              <i className="ri-user-add-line mr-2"></i>
              Inscreva-se Agora
            </button>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-8 text-gray-800">Sobre o Evento</h2>
            <p className="text-xl text-gray-600 leading-relaxed mb-12">
              Um encontro exclusivo promovido pela <strong className="text-blue-600">Brasiline Tecnologia</strong> em parceria com a <strong className="text-blue-600">Fortinet</strong>, reunindo líderes e especialistas para um happy hour com bate-papo estratégico sobre os desafios e oportunidades da cibersegurança moderna.
            </p>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-gradient-to-br from-blue-50 to-white border border-blue-100 rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-semibold mb-3 text-gray-800">Networking Estratégico</h3>
                <p className="text-gray-600">Conecte-se com líderes e tomadores de decisão do setor de tecnologia e segurança.</p>
              </div>
              <div className="bg-gradient-to-br from-blue-50 to-white border border-blue-100 rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-brain-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-semibold mb-3 text-gray-800">Insights Exclusivos</h3>
                <p className="text-gray-600">Discussões aprofundadas sobre tendências e desafios da cibersegurança moderna.</p>
              </div>
              <div className="bg-gradient-to-br from-blue-50 to-white border border-blue-100 rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-rocket-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-semibold mb-3 text-gray-800">Inovação</h3>
                <p className="text-gray-600">Explore as mais recentes tecnologias e soluções em segurança digital.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Topics Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl font-bold text-center mb-16 text-gray-800">Temas em Destaque</h2>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white border border-gray-200 rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:border-blue-30">
                <div className="w-20 h-20 bg-gradient-to-br from-blue-100 to-blue-200 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-government-line text-3xl text-blue-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4 text-gray-800">Risco Cibernético e Governança</h3>
                <p className="text-gray-600 leading-relaxed">
                  Como as empresas podem fortalecer relações e decisões que resistem aos desafios de Cyber e de Negócios.
                </p>
              </div>
              <div className="bg-white border border-gray-200 rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:border-cyan-300">
                <div className="w-20 h-20 bg-gradient-to-br from-cyan-101 to-cyan-200 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-robot-line text-3xl text-cyan-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4 text-gray-800">Inteligência Artificial</h3>
                <p className="text-gray-600 leading-relaxed">
                  Desvendando se a IA é um desafio ou uma aliada da Segurança Cibernética.
                </p>
              </div>
              <div className="bg-white border border-gray-200 rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-30 hover:border-purple-300">
                <div className="w-20 h-20 bg-gradient-to-br from-purple-101 to-purple-200 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-team-line text-3xl text-purple-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4 text-gray-800">Força de Trabalho do Futuro</h3>
                <p className="text-gray-600 leading-relaxed">
                  Estratégias para reduzir o gap de talentos e impulsionar o sucesso das equipes de segurança.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Invite Guest Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-r from-orange-50 to-yellow-50 border border-orange-200 rounded-2xl p-8 text-center shadow-lg">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-100 to-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-3xl">💡</span>
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-800">Indique um convidado!</h3>
              <p className="text-lg text-gray-700 leading-relaxed">
                Se você conhece alguém que possa se beneficiar das soluções e iniciativas da Brasiline, indique abaixo para participar também deste encontro exclusivo.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Registration Form */}
      <section className="py-20 bg-gradient-to-br from-blue-600 to-cyan-600">
        <div className="container mx-auto px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold mb-4 text-white">Inscreva-se Agora</h2>
              <p className="text-xl text-blue-100">
                Garanta sua participação neste evento exclusivo
              </p>
            </div>
            
            <div className="grid lg:grid-cols-2 gap-12 items-start">
              {/* Exclusive Call Box */}
              <div className="text-white relative overflow-hidden h-fit">
                <div className="relative z-10">
                  <h3 className="text-4xl font-bold text-left mb-8 leading-tight">
                    Um Encontro Verdadeiramente Exclusivo
                  </h3>
                  
                  <p className="text-xl text-left leading-relaxed mb-10 text-blue-50">
                    O Brasiline Cyber Day é um evento privado, cuidadosamente planejado para reunir apenas os principais líderes e tomadores de decisão.
                  </p>
                  
                  <div className="bg-white/15 backdrop-blur-sm rounded-2xl p-8 border border-white/30 mb-10 shadow-xl">
                    <div className="flex items-start space-x-4">
                      <div className="w-10 h-10 bg-yellow-400 rounded-full flex items-center justify-center flex-shrink-0 mt-1 shadow-lg">
                        <i className="ri-alert-line text-xl text-gray-800"></i>
                      </div>
                      <div>
                        <h4 className="font-bold text-xl mb-4 text-white">Importante:</h4>
                        <p className="text-blue-50 leading-relaxed text-lg">
                          Este convite é <strong className="text-white">individual, pessoal e intransferível</strong>, restrito a uma pessoa por empresa. Trata-se de um evento altamente seletivo, organizado pela Brasiline em conjunto com a Fortinet.
                        </p>
                        <p className="text-blue-50 leading-relaxed mt-4 text-lg">
                          Para confirmar sua presença, pedimos a gentileza de preencher o formulário ao lado. Caso não seja possível participar, solicitamos que decline para que possamos disponibilizar o convite a outro executivo.
                        </p>
                      </div>
                    </div>
                  </div>
                  
                  <div className="flex items-center justify-start space-x-8">
                    <div className="flex items-center space-x-3 text-blue-100 bg-white/10 px-4 py-2 rounded-full border border-white/20">
                      <i className="ri-user-line text-xl"></i>
                      <span className="text-base font-medium">Apenas Convidados</span>
                    </div>
                    <div className="flex items-center space-x-3 text-blue-100 bg-white/10 px-4 py-2 rounded-full border border-white/20">
                      <i className="ri-shield-check-line text-xl"></i>
                      <span className="text-base font-medium">Evento Privado</span>
                    </div>
                    <div className="flex items-center space-x-3 text-blue-100 bg-white/10 px-4 py-2 rounded-full border border-white/20">
                      <i className="ri-star-line text-xl"></i>
                      <span className="text-base font-medium">Altamente Seletivo</span>
                    </div>
                  </div>
                </div>
              </div>
              {/* Registration Form */}
              <div className="bg-white rounded-2xl p-8 shadow-2xl border border-white/20">
                <iframe 
                  aria-label='Brasiline Cyber Day ' 
                  frameBorder="0" 
                  style={{height:'750px', width:'100%', border:'none'}} 
                  src='https://forms.zohopublic.com/BRASILINE/form/BrasilineCyberDay2025/formperma/jCEsgyrDZglFNF75-HmC1Q6kcJsRcxUeRYQ-yKDV01A'
                  id="inscricao-cyber-day"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-100 py-12">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            {/* Logo and Tagline */}
            <div className="text-left mb-8">
              <div className="flex items-center space-x-4 mb-3">
                <img 
                  src="https://brasiline.com.br/wp-content/uploads/2021/12/Brasiline-Logo-header.svg" 
                  alt="Brasiline Tecnologia" 
                  className="h-10"
                />
                <img 
                  src="https://static.readdy.ai/image/70e35cca528b96dcee707f2af83b401f/4dd715f11861fae5a2492d0192668338.png" 
                  alt="Partner Logo" 
                  className="h-8 opacity-70"
                />
              </div>
              <p className="text-sm text-gray-700 font-medium max-w-xs leading-relaxed">
                Cibersegurança, Infraestrutura e Cloud.<br />
                Este é o nosso negócio!
              </p>
            </div>

            {/* Footer Grid */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
              {/* Soluções */}
              <div>
                <h3 className="text-sm font-bold text-gray-800 mb-4 uppercase tracking-wide">Soluções</h3>
                <ul className="space-y-2">
                  <li>
                    <a 
                      href="https://brasiline.com.br/servico/mss-soc-ciberseguranca-gerenciada/" 
                      className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
                    >
                      MSS - Cibersegurança Gerenciada
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://brasiline.com.br/servico/soc-security-operation-center/" 
                      className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
                    >
                      SOC - Security Operation Center
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://brasiline.com.br/servico/ciberseguranca-e-defesa-de-rede/" 
                      className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
                    >
                      Cibersegurança & Defesa de Rede
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://brasiline.com.br/servico/infraestrutura-de-redes-e-datacenter/" 
                      className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
                    >
                      Infraestrutura de Redes e Datacenter
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://brasiline.com.br/servico/nuvem-brasiline/" 
                      className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
                    >
                      Nuvem Brasiline
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://brasiline.com.br/servico/grc-cybersecurity-framework/" 
                      className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
                    >
                      GRC & Cybersecurity Framework
                    </a>
                  </li>
                </ul>
              </div>

              {/* Links Populares */}
              <div>
                <h3 className="text-sm font-bold text-gray-800 mb-4 uppercase tracking-wide">Links Populares</h3>
                <ul className="space-y-2">
                  <li>
                    <a 
                      href="https://brasiline.com.br/blog/" 
                      className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
                    >
                      Blog
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://brasiline.com.br/eventos/" 
                      className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
                    >
                      Eventos
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://brasiline.com.br/sobre/" 
                      className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
                    >
                      Sobre a Brasiline
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://jobs.brasiline.com.br/jobs/Careers" 
                      className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
                    >
                      Trabalhe Conosco
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://brasiline.com.br/contato/" 
                      className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
                    >
                      Contato
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://brasiline.com.br/compliance/" 
                      className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
                    >
                      Compliance
                    </a>
                  </li>
                </ul>
              </div>

              {/* Fabricantes */}
              <div>
                <h3 className="text-sm font-bold text-gray-800 mb-4 uppercase tracking-wide">Fabricantes</h3>
                <ul className="space-y-2">
                  <li>
                    <a 
                      href="https://brasiline.com.br/fortinet/" 
                      className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
                    >
                      Fortinet
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://brasiline.com.br/kaspersky/" 
                      className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
                    >
                      Kaspersky
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://brasiline.com.br/veeam/" 
                      className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
                    >
                      Veeam
                    </a>
                  </li>
                </ul>
              </div>

              {/* Redes Sociais */}
              <div>
                <h3 className="text-sm font-bold text-gray-800 mb-4 uppercase tracking-wide">Redes Sociais</h3>
                <div className="flex space-x-3 mb-4">
                  <a 
                    href="https://www.facebook.com/BrasilineTecnologia/" 
                    className="w-8 h-8 flex items-center justify-center text-gray-800 hover:text-blue-600 transition-colors cursor-pointer"
                  >
                    <i className="ri-facebook-fill text-lg"></i>
                  </a>
                  <a 
                    href="https://www.youtube.com/c/brasilinetecnologia" 
                    className="w-8 h-8 flex items-center justify-center text-gray-800 hover:text-blue-600 transition-colors cursor-pointer"
                  >
                    <i className="ri-youtube-fill text-lg"></i>
                  </a>
                  <a 
                    href="https://www.instagram.com/brasilinetecnologia/" 
                    className="w-8 h-8 flex items-center justify-center text-gray-800 hover:text-blue-600 transition-colors cursor-pointer"
                  >
                    <i className="ri-instagram-fill text-lg"></i>
                  </a>
                  <a 
                    href="https://www.linkedin.com/company/9996379/admin/dashboard/" 
                    className="w-8 h-8 flex items-center justify-center text-gray-800 hover:text-blue-600 transition-colors cursor-pointer"
                  >
                    <i className="ri-linkedin-fill text-lg"></i>
                  </a>
                  <a 
                    href="https://x.com/brasiline" 
                    className="w-8 h-8 flex items-center justify-center text-gray-800 hover:text-blue-600 transition-colors cursor-pointer"
                  >
                    <i className="ri-twitter-x-fill text-lg"></i>
                  </a>
                </div>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Para saber mais sobre os produtos e serviços Brasiline, fale com um de nossos consultores.
                </p>
              </div>
            </div>

            {/* Copyright */}
            <div className="border-t border-gray-300 pt-6 text-center">
              <p className="text-sm text-gray-600 mb-2">
                © 2025 Brasiline Tecnologia. Todos os direitos reservados.
              </p>
              <p className="text-xs text-gray-500">
                <a href="https://readdy.ai/?origin=logo" className="hover:text-blue-600 transition-colors cursor-pointer">
                  Powered by Readdy
                </a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
